<template>
  <div class="city-contain">
    <div v-for="(item, index) in rankList" :key="index">
      <div v-if="showAll || index < firstSize" class="city-box">
        <div class="city-id">{{index + 1}}</div>
        <div class="city-name" :style="{width:maxWidth + 'px'}">&#160;{{item.city}}</div>
        <div class="right-box">
          <div class="line-box">
            <div class="line" :style="'width:' + (item.mark / maxLine) * 100 + '%'"></div>
            <div class="line bg" :style="'width:' + (100 - (item.mark / maxLine) * 100) + '%'"></div>
          </div>
          <div class="mark">{{item.mark}}</div>
        </div>
      </div>
    </div>
    <div class="axis" :style="'padding-left:' + (maxWidth + 11) + 'px'">
      <div class="a-item">0</div>
      <div class="a-item">1</div>
      <div class="a-item">2</div>
      <div class="a-item">3</div>
      <div class="a-item">4</div>
    </div>
    <div class="more-box" @click="handleShowAll" v-if="!showAll && rankList.length > firstSize">
      <span>展开所有排名</span>
      <img src="../assets/guideSystem/show_more.png" />
    </div>
  </div>
</template>

<script>
    export default {
        name: 'axisRankCharts',
        props: {
            rankList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            firstSize: {
                type: Number,
                default: () => {
                    return 5;
                }
            }
        },
        data () {
            return {
                showAll: false,
                rankListClone: []
            };
        },
        computed: {
            maxWidth () {
                let max = 0;
                let nameArry = [];
                this.rankList.forEach(item => {
                    item.mark = parseInt(item.mark)
                    nameArry.push(item.city);
                });
                if (nameArry.length > 0) {
                    var longest = nameArry.sort(function (a, b) {
                        return b.length - a.length;
                    })[0];
                    max = longest.length * 18.5;
                    return max > 30 ? max : 30;
                } else {
                    return 30;
                }
            },
            maxLine () {
                this.handleShowAll(false)
                return parseInt(this.rankList[0].mark) || 0;
            }
        },
        mounted () {},
        methods: {
            handleShowAll (state = true) {
                this.showAll = state;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .city-box {
    border-bottom: 1px solid #eeeeee;
    height: 34px;
    width: 100%;
    display: flex;
    align-items: center;
    .city-id {
      width: 23px;
      color: #36b374;
      font-size: 14px;
      line-height: 14px;
      font-weight: bold;
      font-family: DIN-Bold, DIN;
    }
    .city-name {
      display: flex;
      justify-content: flex-end;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 10px;
      white-space: nowrap;
    }
    .right-box {
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      .line-box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        .line {
          height: 6px;
          background: #36b374;
          &.bg{
            opacity:0.2;
          }
        }
      }
      .mark {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 10px;
        width: 40px;
        text-align: right;
        white-space: nowrap;
      }
      .rank-box {
        margin-left: 14.7px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        .up-up {
          font-size: 10px;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          line-height: 10px;
          margin-bottom: 2.5px;
        }
        .down-down {
          font-size: 10px;
          font-weight: 400;
          color: rgba(255, 77, 77, 1);
          line-height: 10px;
          margin-bottom: 2.5px;
        }
        .num {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 10px;
          margin-left: 4px;
        }
        .num-up {
          color: rgba(54, 179, 116, 1);
        }
        .num-down {
          color: rgba(255, 77, 77, 1);
        }
      }
    }
  }
  .axis{
    display: flex;
    justify-content: space-between;
    padding-right:33px;
  }
  .more-box {
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #9b9b9b;
    img {
      height: 4px;
      width: 7px;
      margin-left: 3px;
    }
  }
}
</style>
